export const CHART_COLORS = {
  primary: "#7C3AED",
  info: "#2563EB",
  success: "#14B8A6",
  warning: "#F59E0B",
  danger: "#EF4444",
  neutral: "#64748B",
  empty: "#E2E8F0",
} as const;

export const CHART_CATEGORICAL_PALETTE = [
  CHART_COLORS.primary,
  CHART_COLORS.info,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.danger,
] as const;

export const CHART_STYLE = {
  animationSpeed: 350,
  barBorderRadius: 3,
  barSize: "56%",
  heatmapRadius: 3,
  gridColor: "var(--fuse-border)",
  textColor: "var(--fuse-text-secondary)",
  valueLabelColor: "#475569",
} as const;

const BOOKING_STATUS_COLORS: Record<string, string> = {
  canceled: CHART_COLORS.danger,
  cancelled: CHART_COLORS.danger,
  completed: CHART_COLORS.success,
  confirmed: CHART_COLORS.info,
  maintenance: CHART_COLORS.warning,
  no_show: CHART_COLORS.neutral,
  tentative: CHART_COLORS.primary,
};

export function chartColorForBookingStatus(
  status: string,
  fallbackIndex = 0,
): string {
  const normalizedStatus = status
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  return (
    BOOKING_STATUS_COLORS[normalizedStatus] ??
    CHART_CATEGORICAL_PALETTE[fallbackIndex % CHART_CATEGORICAL_PALETTE.length]
  );
}

export function chartColorsForBookingStatuses(statuses: string[]): string[] {
  return statuses.map((status, index) =>
    chartColorForBookingStatus(status, index),
  );
}
